export const MEMORY = 'memory'
export const JEWELZ = 'jewelz'
export const COLLECT = 'collect'
export const PUZZLE = 'puzzle'

export const games = [ MEMORY, JEWELZ, COLLECT, PUZZLE ]